export default __webpack_public_path__ + "static/media/dashboard.13a855cc.jpg";